'use strict';

import moment from 'moment';
import * as actionTypes from '../constants/actionTypes';
import {TABS} from "../utilities/enums";


const initialState = {
  today: moment(),
  selectedDate: moment(),
  visibleYear: moment(), // the year that is currently visible
  job: null,
  latestEntries: null,
  isNewEntry: true,
  isNotesDocumentsOnly: false,
  scheduleEntryShowType: '', // notes, documents
  entry: null,
  entriesLoading: false,
};

export default function calendarReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CALENDAR_SHOW:
      if (action.payload.job) {
        let year = state.visibleYear;
        let selectedDate = state.selectedDate;

        const appDate = action.payload.job.appointmentDate;
        if (appDate && appDate.length > 0) {
          const m = moment(appDate[0]);
          year.set(m.year());
          selectedDate = m;
          return {
            ...state,
            job: action.payload.job,
            visibleYear: year,
            selectedDate: selectedDate,
          };
        }
      }
      return {...state, job: action.payload.job, visibleYear: moment(), selectedDate: moment()};
    case actionTypes.CALENDAR_SELECT_DAY:
      return {
        ...state,
        selectedDate: moment({
          year: state.visibleYear.year(),
          month: +action.payload.month,
          day: +action.payload.day
        })
      };
    case actionTypes.CALENDAR_SELECT_YEAR:
      const m = moment(state.visibleYear);
      m.add(action.payload, 'years');
      return {...state, visibleYear: m};
    case actionTypes.CALENDAR_FETCHING_ENTRIES:
      return {...state, entriesLoading: true};
    case actionTypes.CALENDAR_FETCHED_ENTRIES:
      return {...state, latestEntries: action.payload.scheduleEntries, entriesLoading: false};
    case actionTypes.CALENDAR_SHOW_SCHEDULE_ENTRY:
      return {...state, isNewEntry: action.payload.isNew, entry: action.payload.entry, scheduleEntryShowType: TABS.PROFILE};
    case actionTypes.CALENDAR_SHOW_SCHEDULE_ENTRY_DOCS_DOCUMENTS_ONLY:
      return {...state, isNewEntry: true, isNotesDocumentsOnly: true,
        job: action.payload.job, scheduleEntryShowType: action.payload.what};
    case actionTypes.JOB_BOARD_NOTE_SAVED: {
      const {job} = state;
      if (job.id === action.payload.jobId && job.jobIdType === action.payload.jobIdType){
        job.notes = job.notes || [];
        job.notes.unshift(action.payload.note);
        return {...state, job};
      }
    }
      break;
    case actionTypes.JOB_BOARD_DOCUMENT_SAVED: {
      const {job} = state;
      if (job.id === action.payload.jobId && job.jobIdType === action.payload.jobIdType){
        job.documents = job.documents || [];
        job.documents.unshift(action.payload.document);
        return {...state, job};
      }
    }
      break;
  }

  return state;
}

